import { PurchaseOrderReturn, PurchaseOrderReturnGridResponse } from './../../../../model/common/common.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import { PurchaseOrder, PurchaseOrderGridResponse, RecentInteractions, gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import _ from 'lodash';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReportLookupComponent } from '../../../Reports/report-lookup/report-lookup.component';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EmailTemplateService } from '../../../../services/email-template.service';
import { CustomerService } from '../../../../services/customer.service';
import { SalesService } from '../../../../services/sales.service';
import { Observable, of } from 'rxjs';
import { ReportCenterService } from '../../../../services/report-center.service';
import { InventoryService } from '../../../../services/inventory.service';
import { AdministratorService } from '../../../../services/administrator.service';

@Component({
  selector: 'app-list-purchaseorder',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './list-returnpurchaseorder.component.html',
  styleUrls: ['./list-returnpurchaseorder.component.scss']
})
export class ListReturnPurchaseorderComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;

  selectedPOrder: PurchaseOrderReturn[] = [];
  searchKey: string | undefined;
  paginator: boolean | undefined;
  Data: any;
  unitLabel: string = ''; 
  ReportPath: any;
  companyInfo: any = {};
  projectBoMNameCache: { [key: string]: string } = {};

  constructor(
    private route: Router,
    private porderservice: PurchaseorderService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    private emailTemplateService: EmailTemplateService,
    private salesService: SalesService,
    private reportService : ReportCenterService,
    public inventoryService: InventoryService,
    private warehouseService: AdministratorService

  ) { }

  loader: boolean = false;

  result: PurchaseOrderReturnGridResponse = {
    purchaseOrderReturn: [],
    totalRecords: 0
  };
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 10
  };
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  };

  ngOnInit(): void {
    document.title = 'Purchase Return List';
    this.getPurchaOrder(this.pageRequest);
    this.searchEffect();
    this.getCompanyDetails();
     this.inventoryService.getUnitByAppKey('unitNameLabel')  
    .subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit'; 
    });
  }


  getPurchaOrder(data: gridPageRequest): void {
    this.loader = true;
    this.porderservice.getPOReturn(data).subscribe({
      next: (data: any) => {
        this.result = data as PurchaseOrderReturnGridResponse;
        this.loader = false;
      },
      error: (error) => {
        console.log(error);
        this.loader = false;
      }
    });
  }

  deletePOrder(): void {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {

        var returnPurchaseOrderId = _.map(this.selectedPOrder, 'returnPurchaseOrderId');
        if (returnPurchaseOrderId && returnPurchaseOrderId.length > 0) {
          this.porderservice.deletePOReturn(returnPurchaseOrderId).subscribe({
            next: () => {
              this.selectedPOrder = [];
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted successfully.' });
              this.getPurchaOrder(this.pageRequest);
            },
            error: () => { }
          });
        }

        // if (this.selectedPOrder && this.selectedPOrder.length > 0) {
        //   // var selectedOrdersWithReadyStatus = _.filter(this.selectedPOrder, { 'purchaseOrder_Status': 'Ready' });
        //   var selectedOrdersWithReadyStatus = _.filter(this.selectedPOrder, (order: any) =>
        //     ['Ready', 'Pending Approval'].includes(order.purchaseOrder_Status)
        //   );


        // }
      },
      reject: () => { }
    });
  }

  editPOrder(data?: any): void {
    if (data) {
      this.route.navigate(['/home/Return-PO'], { queryParams: { 'returnPurchaseOrderId': data }, skipLocationChange: false });
    } else {
      this.route.navigate(['/home/Return-PO'], { queryParams: { 'returnPurchaseOrderId': this.selectedPOrder[0].returnPurchaseOrderId }, skipLocationChange: false });
    }
  }

  CreatePOrder(): void {
    this.route.navigate(['home/Return-PO']);
  }

  loadPOrder(event: any): void {
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchPO();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getPurchaOrder(this.pageRequest);
    }
  }


 showReport(value: any): void {
  const formCode = 'PurchaseOrderReturn';

  this.reportService.getReportName(formCode).subscribe({
    next: (report: any) => {
      const receiptNumber = value.receiptNumber;

      const sanitizedNumber = receiptNumber ? receiptNumber.replace(/[^a-zA-Z0-9]/g, "_") : 'PurchaseReturn';
      document.title = sanitizedNumber;
      this.ref = this.dialogService.open(ReportLookupComponent, {
        header: 'Purchase Return',
        width: '100%',
        data: {
          OrderNo: receiptNumber,
          ReportName: sanitizedNumber, 
          ReportPath: report.path
        }
      });
      this.ref.onClose.subscribe(() => {
        this.searchKey = '';
        document.title = 'Purchase Return List';
      });
    },
    error: (err: any) => {
      console.error('Report not found for form code:', formCode, err);
    }
  });
}

  searchPO() {
    if (!this.searchKey) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a search keyword' });
      return;
    }

    this.loader = true;

    this.porderservice.autoSearchReturnPO(this.searchKey).subscribe(
      (data: any) => {

        if (Array.isArray(data)) {
          this.result.purchaseOrderReturn = data;

          this.pageRequest.pageSize = this.result.purchaseOrderReturn.length;
          this.gridPagination = {
            ...this.gridPagination,
            totalRecords: this.result.purchaseOrderReturn.length,
          };
          this.paginator = false;
        }
        else if (data && Array.isArray(data.purchaseOrder)) {
          this.result.purchaseOrderReturn = data.purchaseOrder;

          this.pageRequest.pageSize = this.result.purchaseOrderReturn.length;
          this.gridPagination = {
            ...this.gridPagination,
            totalRecords: this.result.purchaseOrderReturn.length,
          };
          this.paginator = false;
        }
        else {
          this.result.purchaseOrderReturn = [];
        }

        this.loader = false;
      },
      (error) => {
        console.error('Search error:', error);
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data' });
      }
    );
  }


  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getPurchaOrder(this.pageRequest);
  }

  sendOrderEmail() {
    if (!this.selectedPOrder || this.selectedPOrder.length === 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select at least one order'
      });
      return;
    }

    const authString = localStorage.getItem('auth');
    if (!authString) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Auth information is missing' });
      return;
    }

    const auth = JSON.parse(authString);
    const formCode = 'PurchaseOrderReturn';
    const tenant = auth?.tenant?.tenantCode;
    
    // Get report path
    this.reportService.getReportName(formCode).subscribe({
      next: (report: any) => {
        this.ReportPath = report.path;
      },
      error: (err: any) => {
        console.error('Report not found for form code:', formCode, err);
      }
    });

    if (!tenant) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Tenant Code is missing' });
      return;
    }

    this.loader = true;
    let processedCount = 0;
    let successCount = 0;
    let skippedCount = 0;
    const totalOrders = this.selectedPOrder.length;

    this.getUserDepartmentName().subscribe(departmentName => {

    this.selectedPOrder.forEach(order => {
      const selectedOrderId = order.returnPurchaseOrderId;

      this.reportService.getReportName(formCode).pipe(

        switchMap((report: any) => {
          if (!report?.path) {
            throw new Error('REPORT_MISSING');
          }

          return this.porderservice.getPurchaseOrderRetunById(selectedOrderId).pipe(
            map(orderData => ({
              orderData,
              reportPath: report.path
            }))
          );
        }),

        switchMap(({ orderData, reportPath }) => {

          if (!orderData?.vendor?.email) {
            throw new Error('Vendor email not found');
          }

          const formatCurrency = (value: number) =>
            `₹${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

          return this.salesService
            .getEmailTemplate(tenant, 'purchase-order-return-email-template')
            .pipe(
              map((templateResponse: any) => {

                const template =
                  templateResponse?.body ??
                  templateResponse?.Body ??
                  templateResponse?.templateBody ??
                  templateResponse?.TemplateBody ??
                  templateResponse?.emailBody ??
                  templateResponse?.EmailBody;

                if (!template) {
                  throw new Error('Email template body not found');
                }

                const templateData = {
                  vendorName: orderData.vendor.vendorName,
                  orderNumber: orderData.receiptNumber,
                  returnDate: orderData.returnDate
                    ? new Date(orderData.returnDate).toLocaleDateString()
                    : 'N/A',
                  shipToName: orderData.warehouse?.warehouseName || 'N/A',
                  warehouseName: orderData.warehouse?.warehouseName || 'N/A',
                  orderTotal: formatCurrency(orderData.poTotal || 0),
                  cgstTotal: formatCurrency(orderData.cgstTotal || 0),
                  sgstTotal: formatCurrency(orderData.sgstTotal || 0),
                  igstTotal: formatCurrency(orderData.igstTotal || 0),
                  taxTotal: formatCurrency(orderData.taxTotal || 0),
                  currentYear: new Date().getFullYear(),
                  companyName: this.companyInfo.companyName || '',
                  companyEmail: this.companyInfo.companyEmail || '',
                  companyPhone: this.companyInfo.companyPhone || '',
                  companyWebsite: this.companyInfo.companyWebsite || ''
                };

                const emailBody =
                  this.emailTemplateService.replacePlaceholders(template, templateData);

                return { orderData, reportPath, emailBody };
              })
            );
        }),

        switchMap(({ orderData, reportPath, emailBody }) => {

          const emailData = {
            EmailToId: orderData.vendor.email,
            EmailToName: orderData.vendor.vendorName,
            EmailSubject: `Purchase Order Return ${orderData.receiptNumber} from ${this.companyInfo?.companyName || 'our company'}`,
            EmailBody: emailBody,
            OrderNumber: orderData.receiptNumber,
            OrderType: 'Purchase Order Return',
            TenantId: tenant,
            ReportPath: reportPath,
            DepartmentName: departmentName 
          };

          return this.salesService.SendMail(emailData).pipe(
            map(() => orderData)
          );
        }),

        catchError(err => {
          console.error('Email failed:', err.message || err);
          processedCount++;
          if (processedCount === totalOrders) {
            this.loader = false;
          }
          return of(null);
        })
      ).subscribe(result => {

        if (result) {
          successCount++;
          this.createRecentInteractions(result, departmentName);
        }

        processedCount++;

        if (processedCount === totalOrders) {
          this.loader = false;

          if (successCount === 0) {
            this.messageService.add({
              severity: 'warn',
              summary: 'No Emails Sent',
              detail: 'Emails were not sent because required data (report / email / template) was missing.'
            });
          }
          else if (successCount < totalOrders) {
            this.messageService.add({
              severity: 'warn',
              summary: 'Partial Success',
              detail: `${successCount} email(s) sent. ${skippedCount} skipped due to validation issues.`
            });
          }
          else {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: `Successfully sent ${successCount} email(s).`
            });
          }

          this.selectedPOrder = [];
        }
      });
    });
  });

  }

  getCompanyDetails() {
    this.warehouseService.getCompanyDetails().subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          const company = data[0];
          this.companyInfo = {
            companyName: company.companyName,
            companyEmail: company.emailID1,
            companyPhone: company.mobile,
            companyWebsite: `https://${company.website?.replace(/^https?:\/\//, '')}`,
          };
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  createRecentInteractions(formData: any, departmentName: string = '') {
    const nowUTC = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(nowUTC.getTime() + istOffset);

    const appKey = departmentName ? `dept.email.${departmentName}` : 'emailid';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (config: any) => {
        const fromEmail = config?.data || 'default@example.com';

        const recentInteraction: RecentInteractions = {
          sendDate: istDate,
          type: 'Send Mail',
          from: fromEmail,
          to: formData.vendor?.email || 'default@example.com',
          subject: `Purchase Order Return ${formData.purchaseOrderNumber || formData.receiptNumber}`,
          vendorNumber: formData.vendorCode ?? '',
          description: "Purchase Order Return successfully sent",
          createdBy: localStorage.getItem('username') || '',
          isActive: true
        };

        this.salesService.createRecentInteractions(recentInteraction).subscribe({
          next: res => console.log('Recent interaction created:', res),
          error: err => console.error('Recent interaction error:', err)
        });
      },
      error: err => console.error('Recent interaction error:', err)
    });
  }

  getUserDepartmentName(): Observable<string> {
    const authString = localStorage.getItem('auth');
    if (!authString) return of('');

    const auth = JSON.parse(authString);
    const user = auth?.user;

    if (!user?.id) return of('');

    return this.warehouseService.getUserById(user.id).pipe(
      switchMap((userData: any) => {
        const departmentId =
          userData?.departmentId;

        if (!departmentId) return of('');

        return this.porderservice.getDepartmentById(departmentId);
      }),
      map((departmentData: any) => {
        return departmentData?.departmentName;
      }),
      catchError(err => {
        console.error('Error fetching department name:', err);
        return of('');
      })
    );
  }

  placeholder: string = 'Search By ';
  private messages: string[] = ['Purchase Return',	'Return Date',	'Vendor Name',	'Unit Name',	'Total Amount',	'Status', 'Created By'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }
}
